import styled from "styled-components";

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    padding-left: 100px;
    padding-right: 100px;
    width: 550px;
`;